<script>
export default {
    name: "FinancialPeriods",

    data() {

        return {
            fps: [],
            addFinancialPeriod: false,
            financialPeriod: {
                periodID: 0,
                startDate: this.$moment().format(`YYYY-MM-DD`),
                endDate: this.$moment().add(1, `year`).format(`YYYY-MM-DD`),
                userName: this.$root.username,
                active: true,
            },
        };
    },

    mounted() {
        this.$root.loading = true;
        Promise.all([ this.fetchFinancialPeriods(), ]).then(() => {
            this.$root.loading = false;
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        fetchFinancialPeriods() {

            return this.$http.get(`Accounts/GetFinancialPeriods`).then(({ data }) => {
                this.fps = data;
            }).catch(() => {});
        },

    },

    components: {
        "financial-period-form": () => import('./Form.vue'),
    },
}
</script>
<template>
<tail-base-layout>
  <template v-slot:breadcrum>
      <div class="bg-blue-800 p-tiny text-xs text-white rounded">
         <nav class="bg-grey-light rounded font-sans w-full p-tiny">
           <ol class="list-reset flex text-grey-dark">
             <li>
                <router-link 
                    :to="{name : `master-data.accounts.index` }">
                        Accounts master data</router-link>
             </li>
             <li><span class="mx-2">/</span></li>
             <li>Financial Periods</li>
           </ol>
         </nav>
      </div>
  </template>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
          <h5 class="text-sm">Financial Periods</h5>
        </template>
        <template v-slot:card-body>
            <div class="w-full flex flex-wrap">
                <div class="w-full text-right mb-1">
                    <button
                        @click.prevent="addFinancialPeriod=true"
                        class="btn-sm btn-primary text-xs rounded">Add Financial Period</button>
                </div>
                <financial-period-form 
                    :showModal="addFinancialPeriod"
                    @closeModal="addFinancialPeriod=false"
                    @refresh="() => {
                        financialPeriod = {
                            periodID: 0,
                            startDate: $moment().format(`YYYY-MM-DD`),
                            endDate: $moment().add(1, `year`).format(`YYYY-MM-DD`),
                            userName: $root.username,
                            active: true,
                        }
                    }"
                    :financialPeriod="financialPeriod"
                />
                <div class="w-full overflow-auto" style="max-height:35rem;">
                    <table class="table text-xs">
                        <thead class="bg-blue-500 text-white">
                            <tr>
                                <th class="p-tiny">Name</th>
                                <th class="p-tiny">From </th>
                                <th class="p-tiny">To</th>
                                <th class="p-tiny">Active</th>
                                <th class="p-tiny">Period Active</th>
                                <th class="p-tiny">Action</th>
                            </tr>
                        </thead>
                        <tbody class="bg-gray-100">
                            <tr v-for="fp in fps" :key="fp.periodId">
                                <td class="p-tiny">{{ fp.periodYr }}</td>
                                <td class="p-tiny">{{ fp.startDate | dateFormat }}</td>
                                <td class="p-tiny">{{ fp.endDate | dateFormat }}</td>
                                <td class="p-tiny">{{ fp.active ? `Active` : `NA` }}</td>
                                <td class="p-tiny">{{ fp.periodActive ? `Active` : `NA` }}</td>
                                <td class="p-tiny">
                                    <button 
                                        @click.prevent="() => {
                                            financialPeriod={
                                                ...fp,
                                                startDate: $moment(fp.startDate).format(`YYYY-MM-DD`),
                                                endDate: $moment(fp.endDate).format(`YYYY-MM-DD`),
                                                periodID: fp.periodId,
                                            };
                                            addFinancialPeriod=true;
                                        }"
                                        class="btn-sm btn-info text-xs rounded">Edit</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>